import Modal from '../shared/modal';
import PropTypes from 'prop-types';
import React from 'react';

import CapeCodRegionMap from './maps/capecod';
import GreenwichRegionMap from './maps/greenwich';
import HamptonsRegionMap from './maps/hamptons';
import HoustonRegionMap from './maps/houston';
import LaRegionMap from './maps/losangeles';
import MontereyRegionMap from './maps/monterey';
import NycRegionMap from './maps/nyc';
import PalmBeachRegionMap from './maps/palmbeach';
import PasadenaRegionMap from './maps/pasadena';
import SanFranRegionMap from './maps/sanfran';
import SantaBarbaraRegionMap from './maps/santabarb';
import SantaFeRegionMap from './maps/santafe';
import SantaYnezRegionMap from './maps/santaynez';
import SonomaRegionMap from './maps/sonoma';
import VenturaRegionMap from './maps/ventura';

import $ from 'jquery';

const maps = {
  'capecod': CapeCodRegionMap,
  'greenwich': GreenwichRegionMap,
  'hamptons': HamptonsRegionMap,
  'houston': HoustonRegionMap,
  'Los-Angeles-Real-Estate': LaRegionMap,
  'Monterey-Real-Estate': MontereyRegionMap,
  'nyc': NycRegionMap,
  'palmbeach': PalmBeachRegionMap,
  'Pasadena-Real-Estate': PasadenaRegionMap,
  'San-Francisco-Real-Estate': SanFranRegionMap,
  'Santa-Barbara-Real-Estate': SantaBarbaraRegionMap,
  'Santa-Fe-Real-Estate': SantaFeRegionMap,
  'Santa-Ynez-Real-Estate': SantaYnezRegionMap,
  'Sonoma-Real-Estate': SonomaRegionMap,
  'Ventura-Real-Estate': VenturaRegionMap
};

class LocationMap extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      isOpen: false
    };
  }

  componentDidMount(){
    $(window).on('locationMap.open', this.openModal);
    $(window).on('locationMap.close', this.closeModal);
  }

  componentWillUnmount(){
    $(window).off('locationMap.open', this.openModal);
    $(window).off('locationMap.close', this.closeModal);
  }

  openModal = (e, region) => {
    this.setState({isOpen:true, region: region});
    e.stopPropagation();
  }

  close = (e) => {
    e.preventDefault();
    this.setState({isOpen:false});
  }

  render() {
    let Map = maps[this.state.region];
    let modal;
    if (this.state.isOpen) {
      modal = (
        <Modal isOpen={this.state.isOpen} transitionName="fade">
          <div className="modal-dialog" id="location-dialog">
            <div className="modal-header">
              <button type="button" className="close" aria-label="Close" onClick={this.close}><span aria-hidden="true">×</span>
              </button>
              <h4 className="modal-title">SELECT THE LOCATIONS ON THE MAP BELOW</h4>
            </div>
              <div className="modal-body">
                <Map
                  locations={this.props.locations}
                  handleChange={this.props.handleChange}
                  config={this.props.config}/>
                <div className="modal-footer">
                  <a href='#' className="primary-button" onClick={this.close}>Close</a>
                </div>
              </div>
          </div>
        </Modal>
      );
    }
    return (
      <span id="modal-locations">
        {modal}
      </span>
    );
  }
}

LocationMap.propTypes = {
  config: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  locations: PropTypes.array.isRequired
};

export default LocationMap;


// WEBPACK FOOTER //
// ./src/components/search/location-map.jsx